import React, { Fragment, useEffect, useState } from 'react';
import {
    Button,
} from 'reactstrap';
import moment from 'moment';
import { CSVLink } from "react-csv";
import { AxiosAPI, getGroupID } from './../../../../../helpers/AxiosAPI';
import { gAPI_BookingEngineSearch_List } from '../../../../../constants/APIs';
import IntlMessages from '../../../../../helpers/IntlMessages';

const BookingEngineStats = ({ isBookingEngineConnect,
    propertyId,
    fromDate,
    toDate, bookingEngineSearchData, booknow
}) => {
    const [csvData, setCSVData] = useState([]);
    // const numberFormat = (value) =>
    //     new Intl.NumberFormat(locale, {
    //         style: 'currency',
    //         currency: 'NZD'
    //     }).format(value);
    // const getRevenu = (value) => {
    //     return (numberFormat(value).replace(/[A-Za-z]/g, '')).substring(0, numberFormat(value).indexOf('.') - 2)
    // }
    useEffect(() => {
        if (fromDate !== undefined) {
            AxiosAPI({
                method: 'get',
                url: `${gAPI_BookingEngineSearch_List}?groupId=${getGroupID()}&propertyId=${propertyId}&dateFrom=${fromDate}&dateTo=${toDate}`,
            }).then((res) => {
                var tablePrint = [
                    {
                        r1: "Booking Engine Data", r2: "", r3: "", r4: "", r5: "", r6: "", r7: "", r8: ""
                    },
                    {
                        r1: "Start Date :" + moment(fromDate).format('DD') + "/" + moment(fromDate).format('MM') + "/" + moment(fromDate).format('YYYY'), r2: "", r3: "End Date :" + moment(toDate).format('DD') + "/" + moment(toDate).format('MM') + "/" + moment(toDate).format('YYYY'), r4: "", r5: "", r6: "", r7: "", r8: ""
                    },
                    {},
                    {
                        r1: "Check-In Date",
                        r2: "Check-Out Date",
                        r3: "Nights",
                        r4: "Adults",
                        r5: "Childrens",
                        r6: "Promo Code",
                        r7: "Conversation Date",
                        r8: "Average Revenue"
                    },
                ];
                if (res.data.length > 0 && res.data.length > 0) {
                    res.data.map(elem => {
                        tablePrint.push({
                            r1: elem.checkInDate,
                            r2: elem.checkOutDate,
                            r3: elem.nights,
                            r4: elem.adults,
                            r5: elem.childrens,
                            r6: elem.promoCode,
                            r7: moment(elem.createdDate).format('DD') + "/" + moment(elem.createdDate).format('MM') + "/" + moment(elem.createdDate).format('YYYY'),
                            r8: elem.currency + " " + elem.revenue
                        })
                    });
                }
                setCSVData(tablePrint);
            });
        }
    }, [fromDate]);
    return (
        <Fragment>
            <div className="mb-4 col-sm-4 col-lg-3 col-xl-3">
                <div className="card">
                    <div className="text-center card-body">
                        <CSVLink data={csvData} headers={[
                            { key: "r1", label: "" },
                            { key: "r2", label: "" },
                            { key: "r3", label: "" },
                            { key: "r4", label: "" },
                            { key: "r5", label: "" },
                            { key: "r6", label: "" },
                            { key: "r7", label: "" },
                            { key: "r8", label: "" },
                        ]} filename="booking-engine.csv">
                            <Button
                                color="primary"
                                outline
                                size="xs"
                                style={{
                                    display: "block",
                                    position: "absolute",
                                    top: "10px",
                                    right: "5px"
                                }}
                            >
                                Download
                            </Button>
                        </CSVLink>
                        <i className="svg-class"><svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="44.000000pt" height="42.000000pt" viewBox="0 0 44.000000 42.000000" preserveAspectRatio="xMidYMid meet">
                            <g transform="translate(0.000000,42.000000) scale(0.100000,-0.100000)" fill="currentColor" stroke="none">
                                <path d="M25 297 c-10 -24 -1 -187 10 -187 6 -1 11 8 13 20 3 19 10 20 173 20 l169 0 0 -25 c0 -14 5 -25 10 -25 6 0 10 30 10 70 0 40 -4 70 -10 70 -5 0 -10 -15 -11 -32 0 -18 -3 -27 -6 -20 -3 8 -37 12 -118 12 -106 0 -113 1 -118 21 -5 18 -12 21 -51 17 -46 -3 -46 -3 -46 29 0 34 -17 54 -25 30z m110 -82 c0 -12 -40 -19 -61 -11 -9 3 -12 11 -9 16 8 14 70 9 70 -5z m235 -35 c0 -6 -60 -10 -160 -10 -100 0 -160 4 -160 10 0 6 60 10 160 10 100 0 160 -4 160 -10z" />
                            </g>
                        </svg></i>
                        <p className="card-text font-weight-semibold mb-0">
                            <IntlMessages id={`dashboards.number-roomnightsreferred`} /></p>
                        <p className="lead text-center" style={{ fontSize: "1.2rem" }}>
                            {bookingEngineSearchData.nights}
                            {/* {isBookingEngineConnect === true ?
                                bookingEngineSearchData.nights : "" + booknow + "+"} Nights */}
                        </p>
                    </div>
                </div>
            </div>
            <div className="mb-4 col-sm-4 col-lg-3 col-xl-3">
                <div className="card">
                    <div className="text-center card-body">
                        <i className="svg-class"><svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="44.000000pt" height="42.000000pt" viewBox="0 0 44.000000 42.000000" preserveAspectRatio="xMidYMid meet">
                            <g transform="translate(0.000000,42.000000) scale(0.100000,-0.100000)" fill="currentColor" stroke="none">
                                <path d="M70 205 l0 -145 145 0 c90 0 145 4 145 10 0 6 -52 10 -135 10 l-135 0 0 135 c0 83 -4 135 -10 135 -6 0 -10 -55 -10 -145z" />
                                <path d="M317 265 c8 -22 -27 -47 -45 -33 -9 8 -19 5 -35 -10 -18 -17 -26 -19 -35 -10 -10 10 -20 4 -49 -25 -44 -43 -37 -64 7 -22 23 22 33 26 42 17 9 -9 17 -7 35 10 18 17 26 19 35 10 9 -9 19 -6 44 13 17 13 34 21 38 18 3 -4 6 6 6 20 0 22 -5 27 -25 27 -18 0 -23 -4 -18 -15z" />
                            </g>
                        </svg></i>
                        <p className="card-text font-weight-semibold mb-0">
                            <IntlMessages id={`dashboards.number-revenuereferred`} /></p>
                        <p className="lead text-center" style={{ fontSize: "1.2rem" }}>
                            {bookingEngineSearchData.nights !== "" && (
                                <Fragment>
                                    {bookingEngineSearchData.revenue}
                                </Fragment>
                            )}
                            {/* {bookingEngineSearchData.averageDailyRate === 0 ? "N/A" :
                                isBookingEngineConnect === true ?
                                    "" + getRevenu(bookingEngineSearchData.nights * bookingEngineSearchData.averageDailyRate) + "" :
                                    "" + getRevenu(booknow * bookingEngineSearchData.averageDailyRate) + "+"
                            } */}
                        </p>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};
export default BookingEngineStats;